import React from 'react'
import { Box } from 'components/Layout'
import { useAuth, useInsuranceByUser } from '@modmd/data'
import { FormInsurance } from 'client-portal/routes/RequestTestSession/FormInsurance'

export const Insurance = () => {
  const auth = useAuth()
  const insurances = useInsuranceByUser({
    userId: auth.data.User?.id,
  })
  return (
    <Box display="grid">
      {!insurances.loading && (
        <FormInsurance
          userId={auth.data.User?.id?.toString()}
          onClose={() => {}}
          refetchInsurance={() => insurances.refetch()}
          insurances={insurances.data?.getInsuranceByUser}
        />
      )}
    </Box>
  )
}
